// extracted by mini-css-extract-plugin
export default {"container":"confirm-modal_container__zz6iE","actions":"confirm-modal_actions__cbJsl","warning":"confirm-modal_warning__n3xlB"};